/**
 * The pages that each run one forward paper test. They are reached from the
 * Paper tests overview (src/pages/PaperTestsPage.tsx) rather than from the
 * main navigation, which highlights "Paper tests" while one is open. Each
 * page links back to the overview, and `summary` is the one-line description
 * shown both on the overview's card and at the top of the test's own page.
 */
export const PAPER_TEST_PAGES = [
  {
    to: '/crash-bounce',
    label: 'Crash Bounce',
    summary: 'Buy a large coin after a 7-day crash; sell at +10%, −30% or after 7 days.',
  },
  {
    to: '/breakout-watch',
    label: 'Breakout Watch',
    summary:
      'Buy a volume breakout out of a quiet 3-day range. Failed its backtest; tracked anyway.',
  },
  {
    to: '/listing-radar',
    label: 'Listing Radar',
    summary: 'Buy each new Coinbase USD listing once it trades; hold 7 days.',
  },
  {
    to: '/market-maker',
    label: 'Market Maker',
    summary: 'Quote both sides of Kalshi’s BTC 15-minute rounds and earn the spread.',
  },
  {
    to: '/liquidity-rewards',
    label: 'Liquidity Rewards',
    summary:
      'Rest orders on Kalshi markets that pay liquidity rewards; does the reward beat the fills?',
  },
  {
    to: '/martingale',
    label: 'Martingale',
    summary:
      'Always UP, or always DOWN, on BTC 15m, raising the stake after every loss until a win covers it.',
  },
] as const;

export type PaperTestPath = (typeof PAPER_TEST_PAGES)[number]['to'];

export function paperTestSummary(to: PaperTestPath): string {
  return PAPER_TEST_PAGES.find((page) => page.to === to)!.summary;
}

/**
 * Router state a link to the predictor's Rules tab carries when it comes
 * from the Paper tests overview, so that page can offer the way back.
 */
export const FROM_PAPER_TESTS = { from: '/paper-tests' } as const;

export function cameFromPaperTests(state: unknown): boolean {
  return (
    typeof state === 'object' &&
    state !== null &&
    (state as { from?: unknown }).from === FROM_PAPER_TESTS.from
  );
}
